/* ============
 * Vuex Store
 * ============
 *
 * The store of the application
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import application from './modules/application';
import auth from './modules/auth';
import daf from './modules/daf';
import domainGroups from './modules/domain-groups';
import organizations from './modules/organizations';
import organizationConf from './modules/organization-conf';
import perimeters from './modules/perimeters';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    application,
    auth,
    daf,
    domainGroups,
    organizations,
    organizationConf,
    perimeters,
  },
  /**
   * If strict mode should be enabled.
   */
  strict: debug,
});

// Subscribe to store updates
store.subscribe((mutation, state) => {
  // Each time data about a selected perimeter is changing, it is saved in the localstorage
  if (mutation.type === 'perimeters/GET_SELECTED_PERIMETER') {
    localStorage.removeItem('perimeters');
    localStorage.setItem('perimeters', JSON.stringify(state.perimeters.selectedPerimeter));
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js